import React, { useState, useEffect } from 'react';
import html2canvas from 'html2canvas';
import { dateFormatConDiaYHoraShort, getDate } from '../../utils/DateFunctions'
import jsPDF from 'jspdf';

const EntregaPlanPDF = (p) => {
    const width = 1100;
    const height = width * 1.294117647058824;
    const dias_m = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const style1 = "text-s text-bold text-center m-0 p-0 contenedor ";
    const style1b = "text-s text-bold text-center m-0 p-0 contenedor opacity-60";
    const docs_by_page = 9;

    const [reporte, setreporte] = useState([]);

    useEffect(() => {
        make_report();
    }, []);

    const make_report = () => {
        let reps = [];
        let hoja = [];
        for (let i = 0; i < p.data.length; i++) {
            let dt = p.data[i];
            if (dt.id == 45147) console.log(i)
            try {
                let insert = {
                    'id': dt.id,
                    'bloque': dt.bloque,
                    'siembra': dt.semana_siembra,
                    'trans': dt.transplante,
                    'plan_plantas': numberFormat(dt.plantas),
                    'plan_charolas': numberFormat(dt.charolas),
                    'ejecutado_charolas': numberFormat(dt.total_ejecutado),
                    'ejecutado_plantas': numberFormat(dt.plantas_ejecutado),
                    'inventario_plantas': numberFormat(dt.total_aclimatacion),
                    'inventario_charolas': numberFormat(dt.charolas_aclimatacion),
                    'entregado_plantas': numberFormat(dt.total_entregado),
                    'entregado_charolas': numberFormat(dt.charolas_entregadas),
                    'gm_programa': numberFormat(dt.por_germinacion) + "%",
                    'gm_dds': numberFormat(dt.germinacion_real) + "%",
                    'gm_consolidacion': numberFormat(dt.germinacion_envio) + "%",
                    '%ejecutado': porcentaje_divisor(dt.plantas_ejecutado, dt.plantas),
                    '%inventario': porcentaje_divisor(dt.total_aclimatacion, dt.plantas_ejecutado),
                    '%entregado': porcentaje_divisor(dt.total_entregado, dt.total_aclimatacion),
                    'gm_plan': numberFormat(dt.por_germinacion) + "%",
                    'gm_nombre_plan': "Gm programa",
                    'gm_inventario': numberFormat(dt.germinacion_real) + "%",
                    'gm_nombre_inventario': "Gm DDS",
                    'gm_entregado': numberFormat(dt.germinacion_envio) + "%",
                    'gm_nombre_entregado': "Gm consolidacion",
                    'plan': [],
                    'ejecutado': [],
                };
                let total_plan = 0, total_ejecutado = 0;
                for (let j = 0; j < dias.length; j++) {
                    let plan = dias[j] + "_plan";
                    let ejecutado = dias[j] + "_ejecutado";
                    insert.plan.push(dt[plan]);
                    insert.ejecutado.push(dt[ejecutado]);
                }
                insert.tp = total_plan;
                insert.te = total_ejecutado;

                if (hoja.length < docs_by_page) hoja.push(insert);
                else {
                    reps.push([...hoja]);
                    hoja = [];
                }
            } catch (error) {
                console.log(`data`, dt, error);
            }

        }

        if (hoja.length > 0) reps.push(hoja);
        setreporte(reps);
    }

    const numberFormat = (number) => {
        try {
            let format = parseFloat(number);
            if (isNaN(format)) return number;
            return format.toFixed(2);
        } catch (error) {
            return number;
        }
    }

    const porcentaje_divisor = (val1, val2) => {
        try {
            let dividendo = parseFloat(val1);
            if (isNaN(dividendo)) return "NA";

            let divisor = parseFloat(val2);
            if (isNaN(divisor)) return "NA";

            if (divisor <= 0) return "0.00%";
            return (dividendo / divisor * 100).toFixed(2) + "%"
        } catch (error) {
            return "NA";
        }
    }

    const createPDF = async () => {
        if (p.data.length === 0) return;
        p.loader(true);
        const doc = new jsPDF({
            orientation: 'portrait', // 'portrait' para retrato, 'landscape' para apaisado
            unit: 'mm',
            format: [215.9, 279.4], // [ancho, alto]
        });

        for (let i = 0; i < reporte.length; i++) {
            let id = "hojaArr" + i;
            const componentRef = document.getElementById(id); // Reemplaza con el ID de tu componente

            if (componentRef) {
                const canvas = await html2canvas(componentRef, { scale: 1.5 });
                const imgData = canvas.toDataURL('image/png');

                // Calcula el ancho y el alto de la imagen en el PDF
                const imgWidth = 215.9; // Ancho de la página en mm (A4)
                const imgHeight = 279.4;

                // Agrega la imagen como una nueva página al PDF
                if (i > 0) {
                    doc.addPage();
                }
                doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            }
        }

        // Guarda el PDF como un solo archivo
        doc.save('REP_ENTREGA' + getDate());
        p.loader(false);
    };

    return (
        <div className='col-lg-12 p-0 m-0' key={"rtqfqweryeq4w"}>
            <div className='row justify-content-evenly m-0 p-0 w-100 mt-5' style={{ position: "sticky", top: 0, zIndex: 2 }}>
                <div className='col-auto  text-center'>
                    <button className='btn btn-danger mt-2 shadow ps-5 pe-5 round-xxl' onClick={p.close} >Cerrar</button>
                </div>
                <div className='col-auto mt-2 text-center'>
                    <button className='btn btn-warning shadow round-xxl scale-continue-05 text-bold ps-5 pe-5' onClick={createPDF} >Descargar {reporte.length} hoja(s)</button>
                </div>
                <div className='col-lg-12'></div>
                {reporte.map((hoja, k) =>
                    <div key={"hoja aaa" + k} id={"hojaArr" + k} className={'bg-white text-center mt-5 mb-5 p-3 dosis relative ' + (hoja.length === docs_by_page ? " contenedor" : "")}
                        style={{ minWidth: width, maxWidth: width, minHeight: height, maxHeight: height, border: "black solid 2px" }}>
                        <div className='row justify-content-evenly m-0 p-0 w-100'>
                            <div className='col-lg-12 text-end text-s text-300 p-2 m-0 ' style={{ position: "absolute", top: 0, left: 0 }}>
                                <div className='row justify-content-between w-100 m-0 p-0'>
                                    <div className='w-50 text-start m-0 p-0 ps-2'>
                                        Reporte de entrega (Vivero)
                                    </div>
                                    <div className='w-50 text-end m-0 p-0 pe-2'>
                                        Fecha de creación: {dateFormatConDiaYHoraShort(getDate())}
                                    </div>
                                </div>

                            </div>

                            {hoja.map((json, i) =>
                                <div key={k + json.bloque + json.id + " 5845" + i} className={'w-100 m-0 p-0 p-2 ' + (i < (docs_by_page - 1) ? "border-bottom border-dark" : "")}>
                                    <div className='row justify-content-evenly m-0 p-0 w-100'>
                                        <div className='w-50 text-l text-bold'>{json.bloque}</div>
                                        <div className='w-25 text-m'>
                                            <span className='text-m opacity-80 me-2'>Sem. siembra</span>
                                            {json.siembra}</div>
                                        <div className='w-25 text-m'>
                                            <span className='text-m opacity-80 me-2'>Sem. Transplante</span>
                                            {json.trans}
                                        </div>

                                        <div className='col-lg-12 m-0 p-0 mt-2'></div>


                                        {
                                            ['plan', 'ejecutado', 'inventario', 'entregado'].map((val, j) =>
                                                <div className={'text-center m-0 p-0 '} key={j + " rr" + val + i + json.id + " 58fe45" + k}
                                                    style={{ width: '23.5%', borderLeft: j > 0 ? 'solid #CDCDCD 1px' : 'none' }}
                                                >
                                                    <div className='row justify-content-evenly w-100 m-0 p-0 '>
                                                        <div className='col-lg-12 m-0 p-0 text-center text-bold'>{val.toUpperCase()}</div>
                                                        {j > 0 && <div className='w-100'>
                                                            <div className='w-100 text-xs text-bold text-center'>
                                                                Avance
                                                                <span className='w-100 text-center ms-2 text-s text-400'>{json["%" + val]}</span>
                                                            </div>
                                                        </div>}
                                                        {j !== 1 && <div className='w-100'>
                                                            <div className='w-100 text-xs text-bold text-center'>
                                                                {json['gm_nombre_' + val]}
                                                                <span className='w-100 text-center ms-2 text-s text-400'>{json['gm_' + val]}</span>
                                                            </div>
                                                        </div>}
                                                        <div className='w-45'>
                                                            <div className='w-100 text-xs text-bold text-center'>Charolas</div>
                                                            <div className='w-100 text-center'>{json[val + "_charolas"]}</div>
                                                        </div>
                                                        <div className='w-45'>
                                                            <div className='w-100 text-xs text-bold text-center'>Plantas</div>
                                                            <div className='w-100 text-center'>{json[val + "_plantas"]}</div>
                                                        </div>
                                                    </div>

                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                            }
                        </div>
                    </div>)}
            </div>
        </div>
    )
}

export default EntregaPlanPDF;